import { useState } from "react";
import ResendOrSignInLinks from "@/components/singin/ResendOrSignInLinks";

type CheckEmailProps = {
  updateEmail: (email: string) => Promise<string | undefined>;
  message?: string | undefined;
  buttonMessage?: string | undefined;
};

function CheckEmail({ updateEmail, message, buttonMessage }: CheckEmailProps) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  return (
    <>
      <form
        onSubmit={async (e) => {
          // ブラウザ標準の送信（GET）が走るとクエリの oobCode が消えるため、常に止める
          e.preventDefault();
          e.stopPropagation();
          if (submitting) return;
          if (!email) {
            setErr("メールアドレスを入力してください。");
            return;
          }
          setErr("");
          setSubmitting(true);
          const err = await updateEmail(email);
          setSubmitting(false);
          if (err) setErr(err);
        }}
        className="grid grid-cols-5 gap-4"
      >
        <div className="col-span-2 py-4">
          <label htmlFor="email">メールアドレス</label>
          {message && <p className="text-sm mt-2 max-w-60">{message}</p>}
        </div>
        <div className="col-span-3 flex items-center">
          <input
            type="email"
            id="email"
            className="w-full px-6 py-4 border border-gray-300 rounded-md placeholder:font-light"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="flex flex-col items-center justify-center col-span-5">
          {err && <p className="text-red-600">{err}</p>}
          <button
            type="submit"
            className="text-lg px-24 py-3"
            disabled={submitting}
          >
            {buttonMessage ? buttonMessage : "登録する"}
          </button>
        </div>
      </form>
      <ResendOrSignInLinks />
    </>
  );
}

export default CheckEmail;
